export default "__VITE_ASSET__5ac20aac__"